// extracted by mini-css-extract-plugin
export var section = "program-benefits-module--section--YhpK-";
export var wrapper = "program-benefits-module--wrapper--9hjrJ";